import * as React from "react";
const SvgIcBatteryLow = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7 8V16H18V8H7ZM21 5V9H23V15H21V19H1V5H21Z" fill="currentColor" /></svg>;
export default SvgIcBatteryLow;